export const LOG_IN_ROUTE = '/authentication/login';

export const EventsIntegrationTypes: { id: number; name: string }[] = [
  { id: 1, name: 'Entering Zone' },
  { id: 2, name: 'Leaving Zone' },
  { id: 3, name: 'Moving' },
  { id: 4, name: 'Idle' },
  { id: 5, name: 'Stopped' },
  { id: 6, name: 'Motion Start' },
  { id: 7, name: 'Motion Stop' },
  { id: 8, name: 'Amber' },
  { id: 9, name: 'Red' },
  { id: 10, name: 'Stop Arm' },
];
